export const INDUSTRY_VERTICAL_FIELD = 'businessIndustry';

export const DEBOUNCE_DELAY = 300;
export const LIMIT_SEARCH_RESULT = 10;
export const LIMIT_TRIGGER_SEARCH = 50;

const addToString = (list) =>
  list.map((obj) => ({
    ...obj,
    toString() {
      return this.label;
    }
  }));

export const INDUSTRY_CATEGORY_LIST = addToString([
  { label: 'Retail & Consumer Goods', value: 'RetailAndConsumerGoods' },
  { label: 'Financial Services', value: 'FinancialServices' },
  { label: 'Food & Agriculture', value: 'FoodAndAgriculture' },
  { label: 'Healthcare & Pharmaceuticals', value: 'HealthcareAndPharmaceuticals' },
  { label: 'Professional Services', value: 'ProfessionalServices' },
  { label: 'Manufacturing & Industrial', value: 'ManufacturingAndIndustrial' },
  { label: 'Real Estate & Construction', value: 'RealEstateAndConstruction' },
  { label: 'Logistics & Transportation', value: 'LogisticsAndTransportation' },
  { label: 'Wholesale Trade', value: 'WholesaleTrade' },
  { label: 'Business Support Services', value: 'BusinessSupportServices' },
  { label: 'Escort/Dating/Adult Entertainment', value: 'EscortDatingAdultEntertainment' }
]);

export const INDUSTRY_SUBCATEGORY_MAP = {
  RetailAndConsumerGoods: addToString([
    { label: 'Grocery Stores or Supermarkets', value: 'GroceryStoresOrSupermarkets' },
    { label: 'Convenience Stores', value: 'ConvenienceStores' },
    {
      label: 'Specialty Food Retailers (Butcher, Bakery, Produce Markets)',
      value: 'SpecialtyFoodRetailers'
    },
    { label: 'Gas Stations with Retail', value: 'GasStationsWithRetail' },
    {
      label: 'General Merchandise or Department Stores',
      value: 'GeneralMerchandiseOrDepartmentStores'
    },
    { label: 'Online Retail or E-Commerce', value: 'OnlineRetailOrECommerce' },
    { label: 'Subscription and Membership Platforms', value: 'SubscriptionAndMembershipPlatforms' },
    { label: 'Direct-to-consumer Brands', value: 'DirectToConsumerBrands' },
    { label: 'Cannabis', value: 'Cannabis' }
  ]),
  FinancialServices: addToString([
    { label: 'Banks or Credit Unions', value: 'BanksOrCreditUnions' },
    { label: 'FinTech or Payment Processing', value: 'FinTechOrPaymentProcessing' },
    { label: 'Insurance Providers', value: 'InsuranceProviders' },
    {
      label: 'Investment Advisors or Broker Dealers',
      value: 'InvestmentAdvisorsOrBrokerDealers'
    },
    { label: 'Lending or Mortgage Companies', value: 'LendingOrMortgageCompanies' },
    { label: 'Treasury Management Platforms', value: 'TreasuryManagementPlatforms' },
    { label: 'Personal Finance Apps or AI Assistants', value: 'PersonalFinanceAppsOrAIAssistants' },
    { label: 'Retirement Planning', value: 'RetirementPlanning' },
    { label: 'Real Estate Investment Platforms', value: 'RealEstateInvestmentPlatforms' },
    { label: 'Money Service Businesses (MSBs)', value: 'MoneyServiceBusinesses' },
    { label: 'Cryptocurrency', value: 'Cryptocurrency' },
    { label: 'Debt Collection', value: 'DebtCollection' },
    { label: 'Payday Lending', value: 'PaydayLending' },
    { label: 'Gambling', value: 'Gambling' }
  ]),
  FoodAndAgriculture: addToString([
    { label: 'Farms or Agricultural Producers', value: 'FarmsOrAgriculturalProducers' },
    { label: 'Food Wholesalers or Distributors', value: 'FoodWholesalersOrDistributors' },
    { label: 'Restaurants or Cafes', value: 'RestaurantsOrCafes' },
    { label: 'Bars/Nightclubs', value: 'BarsOrNightclubs' },
    { label: 'Catering Services', value: 'CateringServices' },
    { label: 'Farmers Markets', value: 'FarmersMarkets' },
    { label: 'Restaurant Tech & POS Providers', value: 'RestaurantTechAndPOSProviders' }
  ]),
  HealthcareAndPharmaceuticals: addToString([
    { label: 'Hospitals or Clinics', value: 'HospitalsOrClinics' },
    { label: 'Pharmacies', value: 'Pharmacies' },
    { label: 'Medical Equipment Suppliers', value: 'MedicalEquipmentSuppliers' },
    { label: 'Biotechnology Firms', value: 'BiotechnologyFirms' },
    { label: 'Home Health Services', value: 'HomeHealthServices' },
    { label: 'Healthcare Staffing Platforms', value: 'HealthcareStaffingPlatforms' },
    { label: 'Wellness & Benefits Platforms', value: 'WellnessAndBenefitsPlatforms' },
    { label: 'Healthcare and Social Assistance', value: 'HealthcareAndSocialAssistance' }
  ]),
  ProfessionalServices: addToString([
    { label: 'Legal Services', value: 'LegalServices' },
    { label: 'Accounting/Auditing Firms', value: 'AccountingOrAuditingFirms' },
    { label: 'Consulting Firms', value: 'ConsultingFirms' },
    { label: 'Marketing/Advertising Agencies', value: 'MarketingOrAdvertisingAgencies' },
    { label: 'Real Estate Agents/Property Managers', value: 'RealEstateAgentsOrPropertyManagers' },
    { label: 'Corporate Services & Incorporation', value: 'CorporateServicesAndIncorporation' },
    { label: 'HR & Workforce Management Platforms', value: 'HRAndWorkforceManagementPlatforms' },
    { label: 'Direct Marketing or Telemarketing', value: 'DirectMarketingOrTelemarketing' },
    {
      label: 'Legal/Accounting/Consulting or Computer Programming',
      value: 'LegalAccountingConsultingOrComputerProgramming'
    }
  ]),
  ManufacturingAndIndustrial: addToString([
    { label: 'Chemical Manufacturing', value: 'ChemicalManufacturing' },
    { label: 'Electronics/Hardware Manufacturing', value: 'ElectronicsOrHardwareManufacturing' },
    { label: 'Automotive Manufacturing', value: 'AutomotiveManufacturing' },
    { label: 'Construction Materials', value: 'ConstructionMaterials' },
    { label: 'Textiles/Apparel', value: 'TextilesOrApparel' },
    { label: 'Mining', value: 'Mining' }
  ]),
  RealEstateAndConstruction: addToString([
    { label: 'Real Estate', value: 'RealEstate' },
    { label: 'Construction', value: 'Construction' }
  ]),
  LogisticsAndTransportation: addToString([
    { label: 'Transportation or Warehousing', value: 'TransportationOrWarehousing' }
  ]),
  WholesaleTrade: addToString([{ label: 'Wholesale Trade', value: 'WholesaleTrade' }]),
  BusinessSupportServices: addToString([
    { label: 'Business Support or Building Services', value: 'BusinessSupportOrBuildingServices' }
  ]),
  EscortDatingAdultEntertainment: addToString([
    { label: 'Escort Services', value: 'EscortServices' },
    { label: 'Dating or Adult Entertainment', value: 'DatingOrAdultEntertainment' }
  ])
};

export const INDUSTRY_TYPE_LIST = [];

export const UNIT_BUSINESS_VERTICAL_LIST = [
  {
    label: 'Adult Entertainment, Dating or Escort Services',
    value: 'AdultEntertainmentDatingOrEscortServices',
    code: '812990'
  },
  {
    label: 'Agriculture, Forestry, Fishing or Hunting',
    value: 'AgricultureForestryFishingOrHunting',
    code: '11'
  },
  {
    label: 'Arts, Entertainment and Recreation',
    value: 'ArtsEntertainmentAndRecreation',
    code: '71'
  },
  {
    label: 'Business Support or Building Services',
    value: 'BusinessSupportOrBuildingServices',
    code: '56'
  },
  {
    label: 'Cannabis production, distribution, or sales',
    value: 'Cannabis',
    code: '99'
  },
  {
    label: 'Construction',
    value: 'Construction',
    code: '23'
  },
  {
    label: 'Direct Market/Telemarketing',
    value: 'DirectMarketingOrTelemarketing',
    code: '561422'
  },
  {
    label: 'Educational Services',
    value: 'EducationalServices',
    code: '61'
  },
  {
    label: 'Financial Services - Cryptocurrency',
    value: 'FinancialServicesCryptocurrency',
    code: '523160'
  },
  {
    label: 'Financial Services - Debt Collection or Consolidation',
    value: 'FinancialServicesDebitCollectionOrConsolidation',
    code: '561440'
  },
  {
    label: 'Financial Services - Money Services Business or Currency Exchange',
    value: 'FinancialServicesMoneyServicesBusinessOrCurrencyExchange',
    code: '523160'
  },
  {
    label: 'Financial Services - Other',
    value: 'FinancialServicesOther',
    code: '52'
  },
  {
    label: 'Financial Services - Payday Lending',
    value: 'FinancialServicesPaydayLending',
    code: '522390'
  },
  {
    label: 'Gaming/Gambling',
    value: 'GamingOrGambling',
    code: '713290'
  },
  {
    label: 'Health Care and Social Assistance',
    value: 'HealthCareAndSocialAssistance',
    code: '62'
  },
  {
    label: 'Hospitality, Accommodation or Food Services',
    value: 'HospitalityAccommodationOrFoodServices',
    code: '72'
  },
  {
    label: 'Legal, Accounting, Consulting or Computer Programming',
    value: 'LegalAccountingConsultingOrComputerProgramming',
    code: '54'
  },
  {
    label: 'Manufacturing',
    value: 'Manufacturing',
    code: '31'
  },
  {
    label: 'Mining',
    value: 'Mining',
    code: '21'
  },
  {
    label: 'Nutraceuticals',
    value: 'Nutraceuticals',
    code: '446191'
  },
  {
    label: 'Personal Care Services',
    value: 'PersonalCareServices',
    code: '8121'
  },
  {
    label: 'Public Administration',
    value: 'PublicAdministration',
    code: '92'
  },
  {
    label: 'Real Estate',
    value: 'RealEstate',
    code: '53'
  },
  {
    label: 'Religious, Civic and Social Organizations',
    value: 'ReligiousCivicAndSocialOrganizations',
    code: '8131'
  },
  {
    label: 'Repair and Maintenance',
    value: 'RepairAndMaintenance',
    code: '8111'
  },
  {
    label: 'Retail Trade',
    value: 'RetailTrade',
    code: '44'
  },
  {
    label: 'Technology, Media or Telecom',
    value: 'TechnologyMediaOrTelecom',
    code: '51'
  },
  {
    label: 'Transportation or Warehousing',
    value: 'TransportationOrWarehousing',
    code: '48'
  },
  {
    label: 'Utilities',
    value: 'Utilities',
    code: '22'
  },
  {
    label: 'Wholesale Trade',
    value: 'WholesaleTrade',
    code: '42'
  }
].map((obj) => ({
  ...obj,
  toString() {
    return this.label;
  }
}));
